import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Outstationcabservicenavimumbai() {



  const cardData = {
    keyword: " Outstation Cab Service Navi Mumbai ",


"headingDescription": "Royal Route Cab offers reliable outstation cab service in Navi Mumbai, providing safe, comfortable, and affordable long-distance travel for families, business travelers, tourists, and pilgrimage groups. Whether you are planning a weekend getaway, religious trip, or intercity journey, our professional drivers ensure a smooth and stress-free travel experience with timely pickup and well-maintained vehicles. We cover popular destinations like Pune, Lonavala, Nashik, Shirdi, Mahabaleshwar, Goa, Surat, and many more across Maharashtra and neighboring states. Our fleet includes hatchbacks, sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is a trusted choice for outstation cab service in Navi Mumbai.",

topPlaces: [
  {
    "title": "Lonavala & Khandala Hill Station",
    "description": "Lonavala and Khandala are among the most popular outstation getaways from Navi Mumbai, known for misty valleys, lush green hills, waterfalls, and scenic viewpoints like Tiger’s Leap and Bhushi Dam. The monsoon season makes this route especially beautiful for road trips."
  },
  {
    "title": "Pune City",
    "description": "Pune is a major cultural and educational hub located close to Navi Mumbai, offering attractions like Shaniwar Wada, Aga Khan Palace, and vibrant food streets. It is ideal for weekend trips, business travel, and heritage exploration."
  },
  {
    "title": "Alibaug Beaches",
    "description": "Alibaug is a peaceful coastal destination known for clean beaches, beach resorts, and historic forts like Kolaba Fort. It is a perfect short getaway from Navi Mumbai for relaxation and seaside experiences."
  },
  {
    "title": "Mahabaleshwar Hill Station",
    "description": "Mahabaleshwar is a famous hill station known for strawberry farms, scenic viewpoints, waterfalls, and cool climate. Attractions like Arthur’s Seat and Venna Lake make it a favorite long-drive destination."
  },
  {
    "title": "Matheran Hill Station",
    "description": "Matheran is an eco-friendly hill station near Navi Mumbai where vehicles are restricted, offering clean air, forest trails, toy train rides, and viewpoints like Panorama Point and Echo Point."
  },
  {
    "title": "Shirdi (Sai Baba Temple)",
    "description": "Shirdi is one of India’s most important pilgrimage destinations, home to the Sai Baba Temple. It attracts millions of devotees seeking spiritual blessings and peaceful darshan experiences."
  },
  {
    "title": "Igatpuri",
    "description": "Igatpuri is a scenic hill station known for its misty mountains, waterfalls, and the famous Vipassana meditation center. It is a peaceful retreat for nature lovers and spiritual seekers."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a major religious and wine tourism destination known for Trimbakeshwar Temple, Sula Vineyards, and the Godavari River ghats. It is ideal for both spiritual and leisure travel."
  },
  {
    "title": "Ganpatipule",
    "description": "Ganpatipule is a beautiful coastal town in Maharashtra known for its pristine beaches and the famous Swayambhu Ganpati Temple. It offers a calm and scenic beach experience."
  },
  {
    "title": "Aurangabad (Ajanta & Ellora Caves)",
    "description": "Aurangabad is famous for the UNESCO World Heritage Sites of Ajanta and Ellora Caves, showcasing ancient rock-cut architecture, Buddhist paintings, and historical monuments like Bibi Ka Maqbara."
  }
],






services: [
  {
    name: "Cab Hire in Navi Mumbai",
    description: "Cab hire in Navi Mumbai offers flexible travel options for local and outstation journeys. Ideal for daily commuting, airport transfers, and long trips, this service ensures convenience and comfort. Clean vehicles and professional drivers enhance the experience. It guarantees a smooth journey."
  },
  {
    name: "Outstation Cab Service Navi Mumbai",
    description: "Outstation cab service Navi Mumbai provides reliable long-distance travel for business trips, vacations, and family outings. Well-maintained vehicles and experienced drivers ensure safety. It guarantees a comfortable and hassle-free journey."
  },
  {
    name: "Navi Mumbai Outstation Taxi",
    description: "Navi Mumbai outstation taxi offers private and convenient travel for intercity journeys. Ideal for families and corporate travelers. Comfortable seating enhances long trips. It ensures a reliable travel experience."
  },
  {
    name: "Outstation Taxi Service from Navi Mumbai",
    description: "Outstation taxi service from Navi Mumbai ensures smooth travel to various cities with flexible booking options. Professional drivers and clean vehicles enhance comfort. It guarantees safe and dependable travel."
  },
  {
    name: "Book Outstation Cab Navi Mumbai",
    description: "Book outstation cab Navi Mumbai with easy online booking and instant confirmation. Customers can select vehicle type, route, and travel schedule. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Best Outstation Cab Service Navi Mumbai",
    description: "Best outstation cab service Navi Mumbai ensures top-quality vehicles, professional drivers, and excellent customer service. This service focuses on comfort, safety, and punctuality. It guarantees a premium travel experience."
  },
  {
    name: "AC Outstation Cab Navi Mumbai",
    description: "AC outstation cab Navi Mumbai provides comfortable travel in air-conditioned vehicles for long-distance journeys. Ideal for all weather conditions. Spacious seating enhances comfort. It guarantees a pleasant ride."
  },
  {
    name: "Private Outstation Taxi Navi Mumbai",
    description: "Private outstation taxi Navi Mumbai offers exclusive travel for families and business clients. This service ensures privacy and flexible travel plans. Comfortable vehicles enhance the journey. It guarantees a personalized experience."
  },
  {
    name: "Affordable Outstation Cab Navi Mumbai",
    description: "Affordable outstation cab Navi Mumbai offers budget-friendly travel without compromising comfort and safety. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical journeys."
  },
  {
    name: "Reliable Outstation Taxi from Navi Mumbai",
    description: "Reliable outstation taxi from Navi Mumbai provides dependable transportation with verified drivers and well-maintained vehicles. This service ensures timely pickups and smooth travel. It guarantees peace of mind."
  },
  {
    name: "24x7 Outstation Cab Service Navi Mumbai",
    description: "24x7 outstation cab service Navi Mumbai provides round-the-clock availability for all travel needs. Ideal for late-night and early-morning journeys. Quick booking ensures convenience. It guarantees service anytime."
  },
  {
    name: "Outstation Cab Navi Mumbai Fare",
    description: "Outstation cab Navi Mumbai fare is transparent and calculated based on distance, vehicle type, and trip duration. Customers receive clear pricing before booking. It helps in planning travel costs effectively."
  }
],

tableData: [
  ["Cab Hire in Navi Mumbai", "Outstation Cab Service Navi Mumbai"],
  ["Navi Mumbai Outstation Taxi", "Outstation Taxi Service from Navi Mumbai"],
  ["Book Outstation Cab Navi Mumbai", "Best Outstation Cab Service Navi Mumbai"],
  ["AC Outstation Cab Navi Mumbai", "Private Outstation Taxi Navi Mumbai"],
  ["Affordable Outstation Cab Navi Mumbai", "Reliable Outstation Taxi from Navi Mumbai"],
  ["24x7 Outstation Cab Service Navi Mumbai", "Outstation Cab Navi Mumbai Fare"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Outstation Cab Service in Navi Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers dependable outstation cab service from Navi Mumbai for long-distance travel, family trips, and business journeys."
  },
  {
    WhyChooseheading: "Affordable Per KM Pricing",
    WhyChoosedescription: "Outstation cab fares start from approximately ₹10 to ₹16 per km, making travel budget-friendly for all customers."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in interstate and highway routes, ensuring safe and smooth long-distance travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear fare including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel plans based on your requirement."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our outstation cab service in Navi Mumbai operates round the clock for convenient travel anytime."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Long-Distance Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for outstation cab bookings from Navi Mumbai due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide outstation cab service in Navi Mumbai?", answer: "Yes, Royal Route Cabs offers reliable outstation cab services from Navi Mumbai to multiple destinations." },
  { question: "What is the starting fare for outstation cabs?", answer: "Outstation cab fares start from ₹10–₹16 per km depending on vehicle type." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our outstation cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Can I book for interstate travel?", answer: "Yes, we provide interstate cab services with all necessary permits." },
  { question: "Do you provide driver for full trip?", answer: "Yes, all bookings include experienced drivers." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Navi Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Patil",
    feedback: "Outstation cab from Navi Mumbai with Royal Route Cabs was very smooth and well-organized. The long drive felt safe, comfortable, and stress-free throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "Good experience for outstation travel from Navi Mumbai. The cab was clean, the driver was professional, and the journey was comfortable from start to finish.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Cab Service Navi Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/outstation-cab-navi-mumbai.jpg", // replace if needed
  "description": "Book Outstation Cab Service in Navi Mumbai with Royal Route Cabs for safe, affordable, and comfortable long-distance travel. Available for one-way and round-trip journeys with Innova, Ertiga, Dzire, SUV, and sedan taxi options with 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11/km", // indicative outstation rate (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/outstation-cab-service-navi-mumbai"
  }
};



  return (
    <div>

<Helmet>
  <title>Outstation Cab Service Navi Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Outstation Cab Service in Navi Mumbai with Royal Route Cabs. Affordable and reliable long-distance taxi service for one-way and round trips with SUV, Innova, Ertiga, and sedan options."
  />

  <meta
    name="keywords"
    content="outstation cab service navi mumbai, navi mumbai outstation taxi, outstation taxi service from navi mumbai, book outstation cab navi mumbai, best outstation cab service navi mumbai, ac outstation cab navi mumbai, private outstation taxi navi mumbai, affordable outstation cab navi mumbai, reliable outstation taxi from navi mumbai, 24x7 outstation cab service navi mumbai, outstation cab navi mumbai fare, navi mumbai outstation taxi charges, cheapest outstation cab in navi mumbai, outstation cab booking navi mumbai, navi mumbai outstation cab price, innova crysta outstation cab navi mumbai, ertiga outstation cab navi mumbai, swift dzire outstation taxi navi mumbai, sedan outstation cab navi mumbai, suv outstation taxi navi mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/106.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationcabservicenavimumbai;